export default __webpack_public_path__ + "static/media/wireframing.ce739cac.svg";